import { useContext } from 'react';
import type { SidebarContextValues } from './SidebarContext';
import { SidebarContext } from './SidebarContext';

const defaultValues: SidebarContextValues = {
  isSidebarVisible: false,
  isSidebarOpenButtonVisible: false,
  sidebarWidth: 256,
  // Provider 外（サイドバーが存在しないページ）では判定待ちが無いため常に確定扱い
  isSidebarSettled: true,
  toggleSidebar: () => void 0,
};

export const useSidebarContext = (): SidebarContextValues => {
  const sidebarContextValues = useContext(SidebarContext);

  return sidebarContextValues || defaultValues;
};
